import { createSlice, createAsyncThunk } from '@reduxjs/toolkit'
import { getSystemInfo, getAuthLocationDataApi } from 'api'
import { BoundarySlice } from 'redux/reducers'

const initialState = {
    systemData: null, // 分页数据
    authLocationData: null // 有权限的船
}

/* 系统数据 */
export const getSystemInfoAction = createAsyncThunk('AppSlice/getSystemInfoAction', async (_, thunkAPI) => {
    try {
        const { data } = await getSystemInfo()
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})

/* 有权限的船 */
export const getAuthLocationDataAction = createAsyncThunk('AppSlice/getAuthLocationDataAction', async (_, thunkAPI) => {
    try {
        const { data } = await getAuthLocationDataApi()
        return data
    } catch (error) {
        thunkAPI.dispatch(BoundarySlice.actions.addError(error))
    }
})


export const AppSlice = createSlice({
    name: 'AppSlice',
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(getSystemInfoAction.fulfilled, (state, action) => {
            state.systemData = action.payload
        })
        builder.addCase(getAuthLocationDataAction.fulfilled, (state, action) => {
            state.authLocationData = action.payload
        })
    },
})
